import { useMembershipApi } from './useMembershipApi';

export const useGetTopCard = () => {
  const { data: membershipData } = useMembershipApi();

  let topCard = null;
  const membershipList = membershipData?.data?.membership;
  if (Array.isArray(membershipList)) {
    topCard = membershipList.find((membership) => membership?.demographics?.isTopCard);
  }
  return topCard;
};
